import type { ReactNode } from 'react';

import { useState, useContext, useCallback, createContext } from 'react';

interface GestorModeContextProps {
  isGestorMode: boolean;
  toggleGestorMode: () => void;
  enableGestorMode: () => void;
  disableGestorMode: () => void;
}

const GestorModeContext = createContext<GestorModeContextProps | undefined>(undefined);

interface GestorModeProviderProps {
  children: ReactNode;
}

export function GestorModeProvider({ children }: GestorModeProviderProps) {
  const [isGestorMode, setIsGestorMode] = useState(false);

  const toggleGestorMode = useCallback(() => {
    setIsGestorMode((prev) => !prev);
  }, []);

  const enableGestorMode = useCallback(() => {
    setIsGestorMode(true);
  }, []);

  const disableGestorMode = useCallback(() => {
    setIsGestorMode(false);
  }, []);

  return (
    <GestorModeContext.Provider
      value={{
        isGestorMode,
        toggleGestorMode,
        enableGestorMode,
        disableGestorMode,
      }}
    >
      {children}
    </GestorModeContext.Provider>
  );
}

export function useGestorMode() {
  const context = useContext(GestorModeContext);
  if (!context) {
    throw new Error('useGestorMode deve ser usado dentro de GestorModeProvider');
  }
  return context;
}
